const DUPLICATE_CODE_PATTERN = /_DUPLICATE_NAME$/i;
const DUPLICATE_TEXT_PATTERN = /already exists|already in use|unique/i;

export const DUPLICATE_NAME_MESSAGE = "This name is already in use. Enter a different name.";

function extractErrorText(error) {
  const data = error?.response?.data;
  if (typeof data === "string") return data;
  if (Array.isArray(data) && data.length) return String(data[0]);
  if (data && typeof data === "object") {
    if (typeof data.detail === "string") return data.detail;
    const name = data.name;
    if (Array.isArray(name) && name.length) return String(name[0]);
    const nonFieldErrors = data.non_field_errors;
    if (Array.isArray(nonFieldErrors) && nonFieldErrors.length) {
      return String(nonFieldErrors[0]);
    }
    if (typeof data.error === "string") return data.error;
    if (typeof data.message === "string") return data.message;
  }
  return "";
}

/**
 * Whether an API error is a duplicate-organizational-object-name conflict.
 *
 * Supports both the ApiErrorHandlingMiddleware body
 * ({ code: "RESPONSIBILITY_DUPLICATE_NAME", field: "name", detail: "..." })
 * and the legacy message shapes ("Same name already exists", "name": [...], ...).
 */
export function isDuplicateNameError(error) {
  const data = error?.response?.data;
  if (data && typeof data === "object" && typeof data.code === "string") {
    return DUPLICATE_CODE_PATTERN.test(data.code);
  }
  return DUPLICATE_TEXT_PATTERN.test(extractErrorText(error));
}

/**
 * Return the inline copy for a duplicate name, otherwise the API's own
 * (non-internal) error text, otherwise the supplied fallback.
 */
export function getResponsibilityCreateErrorMessage(
  error,
  fallback = "Failed to create responsibility."
) {
  if (isDuplicateNameError(error)) {
    return DUPLICATE_NAME_MESSAGE;
  }

  const text = extractErrorText(error);
  if (text && !/internal server error/i.test(text)) {
    return text;
  }
  return fallback;
}
